<div class="container">
    <div class="left-side">
        <h1>Generate New Image</h1>
        <p>Create unique images using AI generation.</p>
        <label for="imageDescription">Image Description</label>
        <textarea
            id="imageDescription"
            [(ngModel)]="prompt"
            (keydown.enter)="$event.preventDefault()"
            placeholder="Describe the image you want to generate..."></textarea>
        <button
            disableIfNoScenes
            mat-raised-button
            color="primary"
            id="go-to-studio"
            matTooltip="Generate Image"
            (click)="onGenerateImage()">
            <span class="next-btn-content">
                <ng-container *ngIf="!isGeneratingImage; else loader"> Generate Image </ng-container>
                <ng-template #loader>
                    <div class="uploader-status row-centered gapped">
                        <mat-progress-spinner
                            strokeWidth="4"
                            class="loader-icon white-spinner"
                            color="white"
                            mode="indeterminate"
                            diameter="25">
                        </mat-progress-spinner>
                        Generating
                    </div>
                </ng-template>
            </span>
        </button>
    </div>
</div>
